import { useEffect, useState } from "react";

/**
 * Si el dispositivo tiene un puntero FINO, que es la forma honesta de preguntar
 * "estoy en un ordenador": hay raton o trackpad y, por tanto, un teclado con
 * Ctrl+V.
 *
 * No se mira el ancho de la ventana —una tableta con teclado es ancha y un
 * portatil a media pantalla es estrecho— ni el agente de usuario, que miente
 * por diseno. Sirve para DECIR cosas, nunca para decidir que se puede hacer:
 * el pegado se escucha siempre, y esto solo elige si se anuncia.
 */
const FINE = "(pointer: fine)";

export function useFinePointer(): boolean {
  const [fine, setFine] = useState(() => window.matchMedia(FINE).matches);

  useEffect(() => {
    const query = window.matchMedia(FINE);
    const onChange = (event: MediaQueryListEvent): void => setFine(event.matches);

    query.addEventListener("change", onChange);

    /* Entre el primer render y este efecto puede haber cambiado —un movil que
       se acopla a un teclado con trackpad—, asi que se vuelve a leer. */
    setFine(query.matches);

    return () => query.removeEventListener("change", onChange);
  }, []);

  return fine;
}
